// removed by extract-text-webpack-plugin
module.exports = {"container":"_2aaJ8EFXZh8tb8xwe65NZe"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/Ready/Title/Buttons/Resend/styles.css
// module id = 2896
// module chunks = 0